// src/tools/drawing/lineTool.js

/**
 * Фабрика для создания универсального инструмента для рисования линейных объектов.
 * @returns {object} Экземпляр инструмента с методами initialize, activate, deactivate.
 */
const createLineTool = () => {
  let _startDrawing = null;
  let _stopDrawing = null;

  return {
    initialize: (map, options) => {
      console.log('Line tool initialized');
      if (options?.drawingControls) {
        _startDrawing = options.drawingControls.startDrawing;
        _stopDrawing = options.drawingControls.stopDrawing;
      }
    },
    activate: (type, defaultProperties) => {
      console.log(`Line tool activated for type: ${type}`);
      _startDrawing?.('line', defaultProperties);
    },
    deactivate: () => {
      console.log('Line tool deactivated');
      _stopDrawing?.();
    },
    cleanup: () => {},
  };
};

export const lineTool = createLineTool();